import React, { FunctionComponent } from 'react';
import { FormProvider } from 'react-hook-form';

import { Box, Typography } from '@sbv-clients/ui-shared';

import SharedAuthLayout from '../../layouts/shared-auth-layout';
import { useVerifyPhoneNumberResult } from './providers/verify-phone-number.provider';
import { VerifyPhoneFormBody } from './verify-phone-form-body';

export const VerifyPhoneForm: FunctionComponent = () => {
  const { methods, handleSubmit } = useVerifyPhoneNumberResult();

  return (
    <SharedAuthLayout>
      <Box mb={6} textAlign="center">
        <Typography variant="h1" fontWeight={700} mb={2}>
          Validate Phone Number
        </Typography>
        <Typography>
          Please enter your phone number to verify your account and receive a
          one-time password to create a new login or change the password of an
          existing login.
        </Typography>
      </Box>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(handleSubmit)}>
          <VerifyPhoneFormBody />
        </form>
      </FormProvider>
    </SharedAuthLayout>
  );
};
